import { render, staticRenderFns } from "./SingleCustomerSelector.vue?vue&type=template&id=272f0149&scoped=true&"
import script from "./SingleCustomerSelector.vue?vue&type=script&lang=js&"
export * from "./SingleCustomerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272f0149",
  null
  
)

export default component.exports